import React from "react";
import style from "./PredicatedCareerOption.module.css";
import Bg from "/assets/PdfNew/pgbg9.png";
import { capitalize } from "@mui/material";

const PredicatedCareerOption = ({ careerOption }) => {
  const careerInfo = careerOption?.career_info || {};
  const formatLabel = (value = "") => {
    if (!value) return "-";

    return value
      .split(",")
      .map(item =>
        item
          .trim()
          .replace(/_/g, " ")
      )
      .join(", ");
  };
  var careerClusters = {
  "Medical_Science": [
    "Literature",
    "Teacher",
    "Biomedical Science"
  ],
  "Legal_Service": [
    "Journalism",
    "Teaching",
    "Civil Service"
  ],
  "Surgical_And_Interventional": [
    "Biomedical Science",
    "Scientific Research"
  ],
  "Political_Leadership": [
    "Journalism",
    "Social Work",
    "Community Service"
  ],
  "Teaching_And_Research": [
    "Research",
    "Policy Development",
    "Psychology",
    "Writing"
  ],
  "Arts_Performing": [
    "Acting",
    "Writing",
    "Directing",
    "Film Making"
  ],
  "Writing_And_Content_Creation": [
    "Psychology",
    "Media and Social issues",
    "Film Industry",
    "Teaching"
  ],
  "Civil_Service": [
    "International Relations",
    "Governance",
    "Public Policy",
    "Social Work"
  ],
  "Business_And_Entrepreneurship": [
    "Technology",
    "Public Service",
    "Teaching",
    "Business"
  ],
  "Computer_Science_Engineering": [
    "Technology",
    "Engineering",
    "Teaching"
  ],
  "Public_Relation": [
    "Technology & Digital Skills",
    "Creative Arts",
    "Teaching",
    "Business & Entrepreneurship"
  ],
  "Heavy_Engineering": [
    "Technology",
    "Engineering",
    "Teaching"
  ],
  "Fashion_And_Aesthetics": [
    "Industrial Product Design",
    "UI/UX Design",
    "Animation and Visual Communication",
    "Interior Design",
    "Urban Planning"
  ],
  "Design_UX": [
    "Industrial Product Design",
    "UI/UX Design",
    "Animation Visual Communication",
    "Interior Design",
    "Urban Planning"
  ],
  "Defence_Armed_Forces": [
    "Civil Services",
    "Police and Paramilitary Forces",
    "NDRF",
    "Aviation and Defense Support Roles",
    "NCC",
    "NGO",
    "Logistics and Operations Management"
  ],
  "Allied_Health": [
    "Rehabilitation and Therapy",
    "Diagnostics and Laboratory Services",
    "Patient Care and Support Services",
    "Public Health and Preventive Care"
  ],
  "Sales_And_Growth": [
    "Marketing And Branding",
    "Business Development",
    "Customer Relationship Management",
    "Consumer Psychology"
  ],
  "Mental_Health": [
    "Human Resources And Talent Management",
    "Criminology And Forensic Fields",
    "Social Work And Community Services"
  ],
  "Emerging_Career": [
    "Tech and Non-Tech Integration",
    "Non-Tech and Tech Integration",
    "Social Impact and Emerging Fields"
  ],
  "Finanace_And_Commerce": [
    "Management Consulting",
    "Entrepreneurship",
    "Business Strategy"
  ]
}
  return (
    <div className={style.PredicateCareerBg}>
      <img src={Bg} alt="bg" className={style.PredicateCareerBg} />

      <div className={style.content}>
        <h2 className={style.careerTitle}>Top Career Match #{careerOption.priority + 1}: <strong className={style.highlight}>  {formatLabel(careerOption?.career_choice)}</strong></h2>

        {/* Introduction */}
        <p className={style.sectionText}>
          {careerOption?.career_description || "No description available"}
        </p>

        {/* Key Divisions */}
        <p className={style.sectionTitle}>Recommended Sub-Careers & Roles</p>
        <p className={style.scoreDescription}>Key career paths within this cluster include:</p>
        <div className={style.divisionList}>
          <ul>
            {careerInfo?.suggested_sub_categories
              ? careerInfo.suggested_sub_categories
                .split(",")
                .map((division, index) => (
                  <li key={index}>
                    {capitalize(  formatLabel(division))}
                  </li>
                ))
              : <li>-</li>}
          </ul>
        </div>
      <p className={style.sectionTitle}>Secondary Domain</p>

       <div className={style.divisionList}>
          <ul>
            {careerOption?.career_choice && careerClusters[careerOption?.career_choice]
              ? careerClusters[careerOption?.career_choice].map((division, index) => (
                  <li key={index}>
                    {division}
                  </li>
                ))
              : <li>-</li>}
          </ul>
        </div>
        {/* Key Skills & Strengths */}
        <p className={style.sectionTitle}>Why This Career Suits You (Your Strengths)</p>
        <p className={style.scoreDescription}>Based on your personality assessment and aptitude test results, you demonstrate the following
          strengths that align well with this career:
        </p>
        <div className={style.divisionList}>
          <ul>
            {[careerInfo?.aptitude_strength?.split(","), careerInfo?.other_strength?.split(","), careerInfo?.personality_strength?.split(","), careerInfo?.subject_strength?.split(",")]
              ? [careerInfo?.aptitude_strength?.split(","), careerInfo?.other_strength?.split(","), careerInfo?.personality_strength?.split(","), careerInfo?.subject_strength?.split(",")].
                flat()
                .filter(strength => strength)
                .map((strength, index) => (
                  <li key={index}>
                    {capitalize(formatLabel(strength))}
                  </li>
                ))
              : <li>-</li>}
          </ul>
        </div>
        {/* Career–Personality Alignment Score*/}
      
        </div>


      {/* </div> */}
    </div>
  );
};

export default PredicatedCareerOption;
